import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import ProductCard from "../components/ProductCard";
import { useLocation, useNavigate, Link } from "react-router-dom";
//import cloudinary from '../cloudinary-config/cloudinary.js';
import API_URL from "../config";
// Smart search — maps keywords to categories/types
const SEARCH_MAP = {
  shoes:      { category: null, type: "shoes",    label: "Shoes" },
  shoe:       { category: null, type: "shoes",    label: "Shoes" },
  heels:      { category: null, type: "shoes",    label: "Shoes" },
  sandals:    { category: null, type: "shoes",    label: "Shoes" },
  boots:      { category: null, type: "shoes",    label: "Shoes" },
  footwear:   { category: null, type: "shoes",    label: "Shoes" },
  dress:      { category: "women", type: "clothing", label: "Women's Dresses" },
  dresses:    { category: "women", type: "clothing", label: "Women's Dresses" },
  gown:       { category: "women", type: "clothing", label: "Women's Wear" },
  kurti:      { category: "women", type: "clothing", label: "Women's Wear" },
  suit:       { category: "women", type: "clothing", label: "Women's Wear" },
  women:      { category: "women", type: null,       label: "Women" },
  woman:      { category: "women", type: null,       label: "Women" },
  ladies:     { category: "women", type: null,       label: "Women" },
  girls:      { category: "women", type: null,       label: "Women" },
  kids:       { category: "kids",  type: null,       label: "Kids" },
  children:   { category: "kids",  type: null,       label: "Kids" },
  baby:       { category: "kids",  type: null,       label: "Kids" },
  child:      { category: "kids",  type: null,       label: "Kids" },
  cosmetics:  { category: "cosmetics", type: null,   label: "Cosmetics" },
  makeup:     { category: "cosmetics", type: null,   label: "Cosmetics" },
  lipstick:   { category: "cosmetics", type: null,   label: "Cosmetics" },
  foundation: { category: "cosmetics", type: null,   label: "Cosmetics" },
  skincare:   { category: "cosmetics", type: null,   label: "Cosmetics" },
  cream:      { category: "cosmetics", type: null,   label: "Cosmetics" },
  perfume:    { category: "cosmetics", type: null,   label: "Cosmetics" },
  accessories:{ category: null, type: "accessory",   label: "Accessories" },
  bag:        { category: null, type: "accessory",   label: "Accessories" },
  bags:       { category: null, type: "accessory",   label: "Accessories" },
  jewellery:  { category: null, type: "accessory",   label: "Accessories" },
  jewelry:    { category: null, type: "accessory",   label: "Accessories" },
  scarf:      { category: null, type: "accessory",   label: "Accessories" },
  new:        { isNew: true, label: "New Arrivals" },
  "new arrival": { isNew: true, label: "New Arrivals" },
};

export default function Products() {
  const [products,    setProducts]    = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [smartResult, setSmartResult] = useState(null);

  const location  = useLocation();
  const navigate  = useNavigate();
  const params    = new URLSearchParams(location.search);
  const category  = params.get("category");
  const search    = params.get("search");

  useEffect(() => {
    axios.get(`${API_URL}/api/products`)
      .then(r => setAllProducts(r.data))
      .catch(console.error);
  }, []);

  const fetchProducts = useCallback(async () => {
    setLoading(true);
    setSmartResult(null);

    try {
      let url = `${API_URL}/api/products?`;
      if (category) url += `category=${encodeURIComponent(category)}&`;
      if (search)   url += `search=${encodeURIComponent(search)}`;

      const res = await axios.get(url);

      if (res.data.length > 0) {
        setProducts(res.data);
        setSmartResult({ found: true });
      } else if (search) {
        const q = search.toLowerCase().trim();
        const mapped = SEARCH_MAP[q];

        if (mapped) {
          let smartUrl = `${API_URL}/api/products?`;
          if (mapped.category) smartUrl += `category=${mapped.category}&`;
          if (mapped.type)     smartUrl += `search=${mapped.type}&`;
          if (mapped.isNew)    smartUrl += `search=new&`;

          const smartRes = await axios.get(smartUrl);

          if (smartRes.data.length > 0) {
            setProducts(smartRes.data);
            setSmartResult({
              found: true,
              isSuggestion: true,
              label: mapped.label,
              original: search
            });
          } else {
            setProducts([]);
            setSmartResult({ found: false, suggestion: mapped.label, original: search });
          }
        } else {
          const fuzzy = allProducts.filter(p => {
            const name = p.name.toLowerCase();
            const cat  = p.category?.toLowerCase() || "";
            const desc = p.description?.toLowerCase() || "";
            return q.split(" ").some(word =>
              word.length > 2 && (name.includes(word) || cat.includes(word) || desc.includes(word))
            );
          });

          if (fuzzy.length > 0) {
            setProducts(fuzzy);
            setSmartResult({ found: true, isSuggestion: true, label: `results for "${search}"`, original: search });
          } else {
            setProducts([]);
            setSmartResult({ found: false, original: search });
          }
        }
      } else {
        setProducts([]);
        setSmartResult({ found: false });
      }
    } catch (err) {
      console.error(err);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  }, [category, search, allProducts]);

  useEffect(() => {
    fetchProducts();
  }, [category, search, fetchProducts]);

  const pageTitle = search
    ? `"${search}"`
    : category
    ? `${category.charAt(0).toUpperCase() + category.slice(1)}`
    : "All Products";

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,400&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500&display=swap');

        .pr-root *, .pr-root *::before, .pr-root *::after { box-sizing:border-box; }
        .pr-root {
          font-family:'DM Sans',sans-serif;
          background:#fdf9f6;
          min-height:80vh;
          padding: 32px 32px 64px;
          max-width: 1120px;
          margin: 0 auto;
        }
        @media(max-width:768px){ .pr-root{ padding: 20px 16px 48px; } }

        /* ── HEADER ── */
        .pr-header { margin-bottom: 24px; }
        .pr-eyebrow {
          font-size: 9px;
          font-weight: 500;
          letter-spacing: .26em;
          text-transform: uppercase;
          color: #c87090;
          margin-bottom: 6px;
          display: block;
        }
        .pr-title {
          font-family:'Cormorant Garamond',serif;
          font-size: clamp(22px, 4vw, 34px);
          font-weight: 300;
          color: #1a1410;
          margin: 0;
          letter-spacing: -.01em;
          display: block;
        }
        .pr-count {
          font-size: 12px;
          font-weight: 300;
          color: #a09890;
          margin-top: 4px;
          display: block;
        }

        /* ── SMART BANNER ── */
        .pr-smart-banner {
          background: #fff8f0;
          border: 1px solid #f5ddc8;
          padding: 10px 14px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
        }
        .pr-smart-icon { font-size: 14px; flex-shrink: 0; }
        .pr-smart-text { font-size: 12px; color: #5a524c; flex: 1; line-height: 1.5; }
        .pr-smart-text strong { color: #1a1410; font-weight: 500; }

        /* ── NOT FOUND ── */
        .pr-not-found {
          text-align: center;
          padding: 56px 20px;
        }
        .pr-nf-icon {
          font-family:'Cormorant Garamond',serif;
          font-size: 48px;
          color: #ede8e2;
          line-height: 1;
          display: block;
          margin-bottom: 12px;
        }
        .pr-nf-title {
          font-family:'Cormorant Garamond',serif;
          font-size: 22px;
          font-weight: 300;
          color: #1a1410;
          margin: 0 0 8px;
          display: block;
        }
        .pr-nf-sub {
          font-size: 13px;
          font-weight: 300;
          color: #a09890;
          margin-bottom: 22px;
          display: block;
          line-height: 1.6;
        }
        .pr-nf-cats {
          display: flex;
          gap: 8px;
          justify-content: center;
          flex-wrap: wrap;
          margin-bottom: 12px;
        }
        .pr-nf-cat-btn {
          font-size: 10px;
          font-weight: 500;
          letter-spacing: .13em;
          text-transform: uppercase;
          text-decoration: none;
          padding: 8px 16px;
          border: 1.5px solid #ddd8d2;
          color: #5a524c;
          transition: all .18s;
          display: inline-block;
        }
        .pr-nf-cat-btn:hover { border-color: #c87090; color: #c87090; background: #fff5f8; }

        /* ── FILTERS ── */
        .pr-filters {
          display: flex;
          align-items: center;
          gap: 7px;
          margin-bottom: 20px;
          flex-wrap: wrap;
        }
        .pr-filter-tag {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          background: #fff;
          border: 1.5px solid #c87090;
          color: #c87090;
          font-size: 10.5px;
          font-weight: 500;
          padding: 4px 10px;
          border-radius: 20px;
          letter-spacing: .05em;
        }
        .pr-filter-x {
          background: none;
          border: none;
          color: #c87090;
          font-size: 13px;
          cursor: pointer;
          padding: 0;
          line-height: 1;
          display: flex;
          align-items: center;
        }
        .pr-clear-all {
          font-size: 10.5px;
          color: #a09890;
          background: none;
          border: none;
          cursor: pointer;
          text-decoration: underline;
          font-family: 'DM Sans', sans-serif;
          padding: 0;
          transition: color .18s;
        }
        .pr-clear-all:hover { color: #c87090; }

        /* ── ProductCard image override ── */
        .pr-grid img {
          max-height: 160px;
          width: 100%;
          object-fit: cover;
        }
        .pr-grid [class*="img-wrap"],
        .pr-grid [class*="image-wrap"],
        .pr-grid [class*="card-img"] {
          max-height: 160px;
          overflow: hidden;
        }

        /* ── GRID ── */
        .pr-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 14px;
        }
        @media(max-width:900px){ .pr-grid{ grid-template-columns:repeat(2,1fr); gap:10px; } }
        @media(max-width:400px){ .pr-grid{ grid-template-columns:repeat(2,1fr); gap:8px; } }

        /* ── SKELETON ── */
        .pr-skeleton {
          background: #fff;
          border: 1px solid #ede8e2;
          overflow: hidden;
        }
        .pr-sk-img {
          aspect-ratio: 3/4;
          max-height: 160px;
          background: linear-gradient(90deg,#f4f0ec 25%,#ede8e2 50%,#f4f0ec 75%);
          background-size: 200% 100%;
          animation: pr-shimmer 1.4s infinite;
        }
        .pr-sk-body { padding: 10px 12px; }
        .pr-sk-line {
          height: 9px;
          background: linear-gradient(90deg,#f4f0ec 25%,#ede8e2 50%,#f4f0ec 75%);
          background-size: 200% 100%;
          animation: pr-shimmer 1.4s infinite;
          margin-bottom: 7px;
          border-radius: 3px;
        }
        .pr-sk-line.short { width: 60%; }
        @keyframes pr-shimmer {
          from{background-position:200% 0}
          to{background-position:-200% 0}
        }
      `}</style>

      <div className="pr-root">

        {/* HEADER */}
        <div className="pr-header">
          <span className="pr-eyebrow">
            {category ? category : search ? "Search Results" : "Collection"}
          </span>
          <span className="pr-title">{pageTitle}</span>
          {!loading && (
            <span className="pr-count">
              {products.length} product{products.length !== 1 ? "s" : ""} found
            </span>
          )}
        </div>

        {/* SMART SUGGESTION BANNER */}
        {smartResult?.isSuggestion && (
          <div className="pr-smart-banner">
            <span className="pr-smart-icon">💡</span>
            <span className="pr-smart-text">
              No exact match for <strong>"{smartResult.original}"</strong> —
              showing you <strong>{smartResult.label}</strong> instead.
            </span>
          </div>
        )}

        {/* ACTIVE FILTERS */}
        {(category || search) && (
          <div className="pr-filters">
            {category && (
              <span className="pr-filter-tag">
                {category}
                <button className="pr-filter-x"
                  onClick={() => navigate(search ? `/products?search=${search}` : "/products")}>
                  ×
                </button>
              </span>
            )}
            {search && (
              <span className="pr-filter-tag">
                "{search}"
                <button className="pr-filter-x"
                  onClick={() => navigate(category ? `/products?category=${category}` : "/products")}>
                  ×
                </button>
              </span>
            )}
            <button className="pr-clear-all" onClick={() => navigate("/products")}>
              Clear all
            </button>
          </div>
        )}

        {/* LOADING */}
        {loading && (
          <div className="pr-grid">
            {[1,2,3,4,5,6,7,8].map(i => (
              <div key={i} className="pr-skeleton">
                <div className="pr-sk-img" />
                <div className="pr-sk-body">
                  <div className="pr-sk-line short" />
                  <div className="pr-sk-line" />
                  <div className="pr-sk-line short" />
                </div>
              </div>
            ))}
          </div>
        )}

        {/* NOT FOUND */}
        {!loading && products.length === 0 && (
          <div className="pr-not-found">
            <span className="pr-nf-icon">✦</span>
            <span className="pr-nf-title">Nothing found for "{search}"</span>
            <span className="pr-nf-sub">
              This item isn't available yet.<br/>
              Browse our categories below to find something you'll love.
            </span>
            <div className="pr-nf-cats">
              <Link to="/products?category=women"     className="pr-nf-cat-btn">Women</Link>
              <Link to="/products?category=kids"      className="pr-nf-cat-btn">Kids</Link>
              <Link to="/products?category=cosmetics" className="pr-nf-cat-btn">Cosmetics</Link>
              <Link to="/products"                    className="pr-nf-cat-btn">All Products</Link>
            </div>
          </div>
        )}

        {/* PRODUCTS GRID */}
        {!loading && products.length > 0 && (
          <div className="pr-grid">
            {products.map(p => (
              <ProductCard key={p._id} product={p} />
            ))}
          </div>
        )}

      </div>
    </>
  );
}